export default __webpack_public_path__ + "static/media/step1.62476967.webp";